/* eslint-disable no-unused-vars */
import { axios } from '../index'
const resource = '/'

import news from '@/jsons-data/mocks/news.json'
import newsMenu from '@/jsons-data/mocks/news_menu.json'
import footer from '@/jsons-data/mocks/footer.json'
import block_content_top_001 from '@/jsons-data/mocks/block_content_top_001.json'

export default {
  /**
   * ログイン処理
   */
  getNews() {
    const data = {
      data: news
    }
    return new Promise((resolve) => {
      return resolve(data)
    })
  },
  getNewsMenu() {
    const data = {
      data: newsMenu
    }
    return new Promise((resolve) => {
      return resolve(data)
    })
  },
  getNewsId(id, params = {}) {
    return axios.get(`${resource}/news/${id}`, params)
  },

  postSession(params) {
    const data = {
      data: {
        sessionKey: 'dummy'
      }
    }
    return new Promise((resolve) => {
      return resolve(data)
    })
  },
  /**
   * 初回ログイン完了
   */
  putComplete(params) {
    const data = {}
    return new Promise((resolve) => {
      return resolve(data)
    })
  },
  getHeaderFooter() {
    return new Promise((resolve) => {
      resolve({ data: footer })
    })
  },
  getBlockContents(params) {
    return new Promise((resolve) => {
      resolve({ data: block_content_top_001 })
    })
  }
}
